import { inject, Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { AddThirdPartyFormGroup } from "../interfaces/forms/add-third-party-form.interface";

@Injectable({
  providedIn: 'root',
})
export class AddThirdPartyFormService {
  fb = inject(FormBuilder);

  public form: AddThirdPartyFormGroup;

  public init(word: string = '') {
    this.form = this.fb.group({
      word: [word, [Validators.required, Validators.maxLength(100), Validators.pattern(/^[^,'"]+$/)]],
    });
  }
}
